module.exports = __webpack_public_path__ + "img/img_nav_vip_hover.5ce95d1b.svg";